export default "__VITE_ASSET__Dn7EG0l___"